import React from "react";

const RIghtArrowIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.89155 4.55806C8.13563 4.31398 8.53136 4.31398 8.77544 4.55806L13.7754 9.55806C14.0195 9.80214 14.0195 10.1979 13.7754 10.4419L8.77544 15.4419C8.53136 15.686 8.13563 15.686 7.89155 15.4419C7.64748 15.1979 7.64748 14.8021 7.89155 14.5581L12.4496 10L7.89155 5.44194C7.64748 5.19786 7.64748 4.80214 7.89155 4.55806Z"
        fill="#2B244C"
      />
    </svg>
  );
};

export default RIghtArrowIcon;
